(function () {
  function initMarquee(container) {
    if (container.dataset.marqueeInit === 'true') return;
    container.dataset.marqueeInit = 'true';

    var track = container.querySelector('.basiq-reviews__track');
    if (!track) return;

    var speedSeconds = parseFloat(container.dataset.speed) || 28;
    var position = 0;
    var lastTime = null;
    var halfWidth = 0;

    function measure() {
      halfWidth = track.scrollWidth / 3;
    }

    measure();
    window.addEventListener('resize', measure);

    function step(timestamp) {
      if (lastTime === null) lastTime = timestamp;
      var delta = timestamp - lastTime;
      lastTime = timestamp;

      if (halfWidth > 0) {
        var pixelsPerMs = halfWidth / (speedSeconds * 1000);
        position += pixelsPerMs * delta;

        if (position >= halfWidth) {
          position -= halfWidth;
        }

        track.style.transform = 'translateX(' + (-position) + 'px)';
      }

      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function initAll() {
    document.querySelectorAll('.basiq-reviews').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();